import ApiService from '@/services/core/api.service'

const BankService = {
  async get (query = '') {
    return ApiService.get(`admin/banks?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/banks', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/banks/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/banks/${payload.id}`)
  }
}

export default BankService
